// extracted by mini-css-extract-plugin
export default {"phone-widget":"ha9ZF","phone-widget--stop":"er8p7"};